import { getCameraSelector } from '@sophocles/entities/Camera';
import { List } from 'immutable';
import { createSelector } from 'reselect';

export const cameraInterfaceControllerSelector = state => state.entities.cameraInterfaceControllers;

export const getCICSelector = createSelector(cameraInterfaceControllerSelector, getCameraSelector, (cics, cameras) => {
  let newCICs = cics.map(cic => cic.set('cameras', List()));
  cameras.forEach(camera => {
    const cic_id = camera.get('cic', 0) + '';
    const cic = newCICs.get(cic_id, null);
    if (cic != null) {
      const cameras = cic.get('cameras');
      newCICs = newCICs.set(cic_id, cic.set('cameras', cameras.push(camera)));
    }
  });
  return newCICs;
});

export function addRadiosToCIC(a, b) {
  return createSelector(a, b, (cics, radios) =>
    cics.map(cic => {
      if (cic.get('radio') !== null) {
        return cic.set('radio', radios.get(cic.get('radio', 0).toString(), null));
      }
      return cic;
    }),
  );
}
